<div class="app-shell">
  <!-- License expiry banner (top of everything, above sidebar+content) -->
  <app-license-banner *ngIf="!isOnboarding && !isChoosePlan"></app-license-banner>

  <!-- Mobile-only top bar: hidden entirely above the phone breakpoint -->
  <header class="mobile-topbar" *ngIf="!isOnboarding && !isChoosePlan">
    <button
      type="button"
      class="mobile-topbar__menu"
      [class.is-open]="isMobileNavOpen"
      (click)="toggleMobileNav()"
      [attr.aria-expanded]="isMobileNavOpen"
      aria-label="Toggle navigation menu"
    >
      <span class="mobile-topbar__bar"></span>
      <span class="mobile-topbar__bar"></span>
      <span class="mobile-topbar__bar"></span>
    </button>

    <img
      src="/assets/images/logo.svg"
      class="mobile-topbar__logo"
      alt="convverse"
      (click)="goToDashboard()"
    />

    <!-- Mirrors the desktop page-header action; on phones it lives up here so
         it stays reachable without scrolling. -->
    <a
      href="https://companion.convverse.ai"
      target="_blank"
      rel="noopener"
      class="mobile-topbar__companion"
    >
      Start companion
    </a>
  </header>

  <div class="app-container" [ngClass]="{ 'onboarding-mode': isOnboarding || isChoosePlan }">
    <!-- Scrim behind the off-canvas drawer (mobile only) -->
    <div
      class="sidebar-backdrop"
      *ngIf="isMobileNavOpen"
      (click)="closeMobileNav()"
      aria-hidden="true"
    ></div>

    <app-sidebar
      *ngIf="!isOnboarding && !isChoosePlan"
      [isSidebarCollapsed]="isSidebarCollapsed && !isMobile"
      [isMobileOpen]="isMobileNavOpen"
      (sidebarToggle)="onSidebarToggle()"
    >
    </app-sidebar>

    <main class="content" [ngClass]="{ 'content-expanded': isSidebarCollapsed, 'content-full': isOnboarding || isChoosePlan }">
      <div class="content-inner"><router-outlet></router-outlet></div>
    </main>
  </div>

  <!-- Expired / suspended overlay (fixed over entire viewport) -->
  <app-expired-overlay *ngIf="!isOnboarding && !isChoosePlan"></app-expired-overlay>
</div>
